import React from 'react';
import styled from 'styled-components';

import { Icon } from 'src/styledComponents/Icons';

import { theme } from 'styles';

import { Show } from 'components/condition';

import { Text } from '../Typography';
import { BaseButton, getButtonSizes } from './Base';
import { ButtonProps, Message } from './types';

const colors = theme.miles.colors;

const getBackground = (message: keyof typeof Message) => {
  switch (message) {
    case Message.main:
      return {
        default: colors.dark.background.primary,
        hovered: colors.brand.aurora[100],
      };
    case Message.mainSwap:
      return {
        default: colors.dark.background.swapPrimary,
        hovered: colors.brand.cobalt.cobalt700,
      };
    case Message.subtle:
      return {
        default: colors.dark.alpha[300],
        hovered: colors.dark.alpha[500],
      };
    case Message.negative:
      return {
        default: colors.dark.background.negative,
        hovered: colors.brand.secondary.red500,
      };
    default:
      return null;
  }
};

const getTextColor = (message: keyof typeof Message) => {
  switch (message) {
    case Message.main:
      return colors.dark.thin.swapPrimary;
    case Message.mainSwap:
      return colors.dark.thin.primary;
    case Message.subtle:
      return colors.dark.thin.secondary;
    case Message.negative:
      return colors.brand.alphas.light900;
    default:
      return null;
  }
};

const StyledDarkButton = styled(BaseButton)<ButtonProps>`
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.4);
  background: ${(props) => getBackground(props.message)?.default};
  &:hover {
    background: ${(props) => getBackground(props.message)?.hovered};
  }
  color: ${(props) => getTextColor(props.message)};
`;

export const DarkButton: React.FC<ButtonProps> = (props) => {
  const { message, size, children, iconLeft, iconRight, iconName, ...rest } = props;
  return (
    <StyledDarkButton message={message} size={size} {...rest}>
      <Show if={Boolean(iconLeft)}>
        <Icon className='left-icon' name={iconName || ''} size={getButtonSizes(size).icon} />
      </Show>
      <Text weight='bold' size={getButtonSizes(size).text}>
        {children}
      </Text>
      <Show if={Boolean(iconRight)}>
        <Icon className='right-icon' name={iconName || ''} size={getButtonSizes(size).icon} />
      </Show>
    </StyledDarkButton>
  );
};
